<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Merge Employee :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees`">
                            <i class="fa fa-group"></i> Employees
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/view/${EmployeeId}`">
                            {{ employee.FirstName }} {{ employee.LastName }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Merge &amp; Delete <i class="fa fa-trash"></i></li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-6 col-lg-8 col-md-7">
                    <div class="card">
                        <h4 class="card-header">Merge and Delete Employee</h4>
                        <div class="card-body">
                            <div class="alert alert-info">You about to merge this employee into the selected employee below. This will assign all incidents and inspections to the employee in the dropdown and then delete this employee.</div>
                            <!-- <label class="control-label col-md-4">
                                Re-assign Employee
                            </label>
                            <div class="input-group-sm col-md-7">
                                <select name="reassign_EmployeeId" id="employee-id" class="form-control"></select>
                            </div> -->
                            <employee-select v-on:vselected="onEmployeeSelectUpdate" :excludeId="EmployeeId"></employee-select>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-success" v-on:click="mergeEmployee(this)" :disabled="saving">Merge and Delete Employee</button>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                EmployeeId: this.$route.params.id,
                mergeToId: 0,
                employee: {}
            }
        },
        methods: {
            getEmployee: function() {
                //Get the data
                this.$http
                    .get('employees/merge/' + this.EmployeeId)
                    .then(response => {
                        //Set all the data
                        this.employee = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            mergeEmployee: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('employees/merge', {EmployeeId: this.employee.EmployeeId, reassign_EmployeeId: this.mergeToId})
                .then(response => {
                    //Create the messgae
                    var mergeMessage = 'Employee Merged';

                    //Alert the user?
                    this.$toastr.success(mergeMessage);

                    //Return to main list?
                    this.$router.push('/employees');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },
            onEmployeeSelectUpdate (selected) {
                //SEt the id
                this.mergeToId = selected.EmployeeId;
            }
        },
        mounted() {
            //Get the incidents
            this.getEmployee();
        }
    }
</script>
